export const prerender = true; // Tell sveltekit to staticly prerender all pages
export const ssr = true; // Tell sveltekit to server side render all pages
